export const calendarUrl = 'https://calendly.com/marcell-ortutay/fetchfox';
export const discordUrl = 'https://discord.gg/mM54bwdu59';
export const docsUrl = 'https://docs.fetchfox.ai';

export const primaryColor = '#FD953A';
export const primaryColorDark = '#EC6105';

export const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

export const headerHeight = 50;

export const includeContentOptions = [
  ['markdown', 'Markdown'],
  ['html', 'HTML'],
  ['text', 'Text'],
  ['urls', 'URLs'],
  ['images', 'Images'],
  ['jsonLd', 'JSON-LD'],
  ['jsonBlobs', 'JSON Blobs'],
];

// TODO: refactor to remove redundant variables
export const colors = {
  primary: primaryColor,
  primaryDark: primaryColorDark,
  primaryLight: '#fff2e6',
  primaryGradient: 'linear-gradient(145deg, #FD953A 0%, #FB8014 50%, #EC6105 100%)',

  gentleGray: '#555',

  brightBlue: '#0275ff',
  lightBlue: '#def',

  brightGreen: '#16A34A',
  lightGreen: '#D1FAE5',

  brightPurple: '#8B5CF6',
  lightPurple: '#F3E8FF',

  brightOrange: '#F97316',
  lightOrange: '#FFEDD5',

  brightYellow: '#D97706',
  lightYellow: '#FEF9C3',

  linkBlue: 'rgb(9, 105, 218)',
  gray: '#eee',

  green: '#27ae60',
  darkGreen: '#1e8449',
  lightGreen: '#a9dfbf',

  error: '#dc2626',
  lightError: '#f87171',
};

export const styles = {
  uiBox: {
    border: '1px solid #ccc',
    padding: 10,
    borderRadius: 8,
  },

  textOverflowStyle: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  pre: {
    padding: 10,
    border: '1px solid #e3e3e3',
    background: '#f6f6f6',
    borderRadius: 5,
  },

  stickyHeader: {
    position: 'sticky',
    top: headerHeight + 10,
    zIndex: 2,
    background: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 8,
    border: '1px solid #ccc',
    borderRadius: 4,
    marginBottom: 10,
  },
};
